module.exports = __webpack_public_path__ + "bcc6b43db05e8d3d49a7ec0ac5352cc0.fbx";